import {animationTimeline} from "./animationTimeline";
import {getTransitionStep} from "./transitionSteps"




class Router {

    constructor(url) {
        this.canSwipe=true;
        this.routes = [
            {
                id: 0,
                url: '/',
                props:{
                    projectSelected:true,
                }
            },
            {
                id: 1,
                url: '/about',
                props:{
                    projectSelected:false,
                }

            },
            {
                id: 2,
                url: '/mobile-food',
                props:{
                    projectSelected:false,
                    projectIndex:3,
                    imgSelected:1,
                }

            },
            {
                id: 3,
                url: '/repreneur',
                props:{
                    projectSelected:false,
                    projectIndex:1,
                    imgSelected:1,


                }
            },
            {
                id: 4,
                url: '/anazir',
                props:{
                    projectSelected:false,
                    projectIndex:2,
                    imgSelected:1,


                }
            },
            //Ajouter route pour nouveau projet
            {
                id: 5,
                url: '/retronews',
                props:{
                    projectSelected:false,
                    projectIndex:0,
                    imgSelected:1,
                }
            },
        ];
        this.lastRoute=null;
        this.actualRoute = this.getRouteByURL(url);
        window.history.replaceState(this.actualRoute, null, "");
        this.timeLine=null;
        this.inTransition=false;
        this.lastScrollTop=0;

    }
    disableCanSwipeFor(time){
        this.canSwipe=false;
        setTimeout(()=>{this.canSwipe=true; }, time);
    }
    getRouteByURL(urlWanted) {
        let routeFound = null;
        this.routes.forEach(route => {

            if (route.url === urlWanted) {
                routeFound = route;
            }

        });
        return routeFound;
    }
    goForward(url) {
        var route = this.getRouteByURL(url);
        if (route) {
            this.lastRoute=this.actualRoute;
            this.actualRoute = route;
            return this.push()
        }
        else {
            return ("ERROR ROUTE NOT FOUND")
        }
    }

    push() {
        window.history['pushState'](
            this.actualRoute,
            '',
            this.actualRoute.url
        )
        return this.render();
    }

    render() {
       
            
                
                  

                   
                   if(this.inTransition){
                        this.timeLine.stop();
                        this.timeLine.reset();
                   }
                   else{
                    this.inTransition=true
                   }
                   const transition=this.lastRoute?getTransitionStep(this.lastRoute.url, this.actualRoute.url, this):getTransitionStep("load", this.actualRoute.url, this)
                  
                  
                   this.timeLine=animationTimeline(0, 1000,transition);
                  
                  
                   if(this.actualRoute.id===0){
                    this.disableCanSwipeFor(1000);
                   }
                   else if(this.actualRoute.id===1){
                        this.canSwipe=false;
                    }
                   if(this.actualRoute.id===2 || this.actualRoute.id===3 || this.actualRoute.id===4){
                        this.disableCanSwipeFor(2000);
                   }

                   return this.timeLine.start()

                    //aboutToHomeAnimation();
                 
               
        
    }
}
export default Router